import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['accidentalFields', 'justification', 'reasonRadioGroup'];

  connect() {
    this.updateJustificationFields(
      this.reasonRadioGroupTarget.getAttribute('value')
    );
  }

  accidentalStoppage() {
    this.updateJustificationFields('true');
  }

  notAccidentalStoppage() {
    this.updateJustificationFields('false');
  }

  updateJustificationFields(discontinuedInError) {
    const requiresJustification = discontinuedInError === 'false';
    this.accidentalFieldsTarget.classList.toggle(
      'hide',
      !requiresJustification
    );
    this.justificationTarget.required = requiresJustification;
  }
}
